import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef } from "react";

import { useAppDispatch } from "store/store";
import { inputSearch } from "_constants";
import { setSearchTermCode } from "store/slicer/GestioneCodeSlice";
import { useDebounce, useUnmountEffect } from "primereact/hooks";

export const InputSearchCode = () => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, debouncedValue, setInputValue] = useDebounce("", 500);

  const handleChange = (e: any) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    if (debouncedValue !== null && debouncedValue !== undefined) {
      dispatch(setSearchTermCode(debouncedValue));
    }
  }, [debouncedValue, dispatch]);

  useUnmountEffect(() => {
    dispatch(setSearchTermCode(""));
  });

  return (
    <IconField iconPosition="left">
      <InputIcon className="cta pi pi-search"></InputIcon>
      <InputText
        ref={inputRef}
        v-model="value1"
        placeholder={inputSearch}
        value={inputValue}
        onChange={handleChange}
        className="width-100"
      />
    </IconField>
  );
};
